import { createContext} from "react";

export const Context = createContext({
    detail:{},
    filteredArr: [],
    changeTextBtn: () =>{}
})




